import React, { PropsWithChildren } from 'react';

import '../../styles/components/InfoNote.css';

type Props = {
  variant: 'success' | 'info';
  faIcon: string;
} & PropsWithChildren;

export default function InfoNote({ faIcon, children, variant }: Props) {
  return (
    <div className={`info-note alert alert-${variant}`}>
      <span className={`fa ${faIcon} fa-2x`} />
      <div className='info-note__text'>{children}</div>
    </div>
  );
}
